/**
 * @desc the ngBrandedFaresTPL provides support for collect and displaying information of Branded Fares in Purchase 1
 * @example:
 * <div ng-booking-page-one request="bkgData.request" flexy="bkgData.bookingRequest.flexyFare" proposal="proposal" passengers="paxAmount" paxname="paxType" paxinfo="bkgData.bookingRequest.paxes" datelastarrival="lastDate" cards="cards" time="newProcess" selection="bkgData.selection"></div>
 */

webClient.directive("ngBrandedFares", [
    "$window",
    "templateService",
    "$timeout",
    "FARE_STATUS",
    function ($window, templateService, $timeout, FARE_STATUS) {
        var directive = {};
        directive.restrict = "EA";
        directive.scope = {
            proposalslist: "=",
            brandedfaresservices: "=",
            brandkey: "=",
            productistrain: "=",
        };
        directive.link = function ($scope, $element) {
            templateService.compile($scope, $element, "tpl/_BrandedFaresTPL.html");

            //Initialize Variables
            $scope.getUrl = $window.getUrl;

            $scope.severalProposals = ($scope.proposalslist || []).length > 1;

            $scope.hasPaidWithFee = ($scope.proposalslist || []).some(function (p) {
                return ((p.localizedFareConditions && p.localizedFareConditions.flexibility) || []).some(function (item) {
                    return item && item.status === FARE_STATUS.PAID_WITH_FEE;
                });
            });
            $scope.hasFreeOfCharge = ($scope.proposalslist || []).some(function (p) {
                return ((p.localizedFareConditions && p.localizedFareConditions.flexibility) || []).some(function (item) {
                    return item && item.status === FARE_STATUS.FREE_OF_CHARGE;
                });
            });
            $scope.hasFlexibilityFees = ($scope.proposalslist || []).some(function (p) {
                return ((p.localizedFareConditions && p.localizedFareConditions.flexibility) || []).some(function (item) {
                    return item && (item.status === FARE_STATUS.PAID || item.status === FARE_STATUS.PAID_WITH_FEE || item.status === FARE_STATUS.FREE_OF_CHARGE);
                });
            });
            $scope.brandKey =
                $scope.brandkey ||
                ($scope.proposalslist && $scope.proposalslist[0] && $scope.proposalslist[0].brandKey);

            /**
             * SelectBranded
             * Funcion para seleccionar otro proposal (Branded Fare).
             * Esta funcion hace un emit brandClick para notificar en
             * FligthBookingBody que se ha elegido otro proposal.
             * @param {string} fare fare name
             * @param {string} brandKey code
             * @param {int} proposalIndex to select
             */
            $scope.selectBranded = function (fare, brandKey, proposalIndex) {
                $scope.brandKey = brandKey;
                var proposal = ($scope.proposalslist && $scope.proposalslist[proposalIndex]) || {};
                var brandedFaresSelected = {
                    brandKey: brandKey,
                    proposalIndex: proposalIndex,
                    fareWithLugage: proposal.fareWithLugage,
                    fareWithoutBaggage: proposal.fareWithoutBaggage,
                    localizedFareConditions: proposal.localizedFareConditions
                };
                $scope.$emit("brandClick", brandedFaresSelected);

                console.log(brandedFaresSelected);
            };

            $scope.setEqualSlideHeights = function (sliderSelector) {
                var maxHeight = 0;
                var $slides = $(sliderSelector).find(".c-fares-card");

                $slides.css("height", "auto");
                $slides.each(function () {
                    var slideHeight = $(this).outerHeight();
                    if (slideHeight > maxHeight) maxHeight = slideHeight;
                });
                $slides.css("height", maxHeight + "px");
            };

            $scope.onSelectBranded = function (fare, brandKey, proposalIndex) {
                $scope.selectBranded(fare, brandKey, proposalIndex);

                try {
                    if (
                        window.site.partnerId == "rakuten" ||
                        window.site.partnerId == "rakuten-dp"
                    ) {
                        pushInteractionEvent("select_branded_fare", null, null, {
                            BF_proposal_index: proposalIndex,
                        });
                    }
                } catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }
            };

            //Check if there is a branded fare selected
            if ($scope.brandkey != undefined) {
                angular.forEach($scope.proposalslist, function (p) {
                    if (p.brandKey === $scope.brandKey) {
                        $scope.selectBranded(p.brandDisplayName, p.brandKey, p.index);
                    }
                });
            }

            // Init carousel after Angular's $digest has rendered the ng-repeat cards.
            // Mobile (< $md / 768px) uses Siema. Desktop (>= 768px) uses pure CSS flex
            // with native horizontal scroll driven by custom prev/next arrows.
            $timeout(function () {
                var root = $element[0];
                var prev = root.querySelector(".c-custom-prev");
                var next = root.querySelector(".c-custom-next");
                var slider = root.querySelector(".c-fares-slider");
                var mq = $window.matchMedia("(min-width: 768px)");

                var faresSiema = null;
                var desktopBound = false;

                function setEqualHeights() {
                    $scope.setEqualSlideHeights(".c-fares-slider");
                }

                function updateSiemaArrows() {
                    if (this.innerElements.length <= this.perPage) {
                        next.classList.add("d-none");
                        prev.classList.add("d-none");
                        return;
                    }
                    if (this.currentSlide >= this.innerElements.length - this.perPage) {
                        next.classList.add("d-none");
                        prev.classList.remove("d-none");
                    } else if (this.currentSlide === 0) {
                        next.classList.remove("d-none");
                        prev.classList.add("d-none");
                    } else {
                        next.classList.remove("d-none");
                        prev.classList.remove("d-none");
                    }
                }

                function initMobile() {
                    faresSiema = new Siema({
                        selector: ".c-fares-slider",
                        startIndex: 0,
                        draggable: true,
                        loop: false,
                        perPage: {
                            360: 1.1,
                            576: 1.5,
                            768: 2.3,
                            1024: 3.4,
                        },
                        onInit: function () {
                            setTimeout(setEqualHeights, 100);
                            updateSiemaArrows.call(this);
                        },
                        onChange: function () {
                            updateSiemaArrows.call(this);
                        },
                    });
                    prev.onclick = function () { faresSiema.prev(); };
                    next.onclick = function () { faresSiema.next(); };
                }

                function updateDesktopArrows() {
                    var hasOverflow = slider.scrollWidth > slider.clientWidth + 1;
                    if (!hasOverflow) {
                        prev.classList.add("d-none");
                        next.classList.add("d-none");
                        return;
                    }
                    var atStart = slider.scrollLeft <= 0;
                    var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
                    prev.classList.toggle("d-none", atStart);
                    next.classList.toggle("d-none", atEnd);
                }

                function scrollByCard(direction) {
                    var card = slider.querySelector(".c-fares-card");
                    var step = card ? card.offsetWidth + 16 : slider.clientWidth * 0.8;
                    slider.scrollBy({ left: direction * step, behavior: "smooth" });
                }

                function initDesktop() {
                    setTimeout(setEqualHeights, 100);
                    prev.onclick = function () { scrollByCard(-1); };
                    next.onclick = function () { scrollByCard(1); };
                    slider.addEventListener("scroll", updateDesktopArrows);
                    desktopBound = true;
                    setTimeout(updateDesktopArrows, 100);
                }

                function teardown() {
                    if (faresSiema) {
                        try { faresSiema.destroy(true); } catch (e) { /* noop */ }
                        faresSiema = null;
                    }
                    if (desktopBound) {
                        slider.removeEventListener("scroll", updateDesktopArrows);
                        desktopBound = false;
                    }
                    prev.onclick = null;
                    next.onclick = null;
                }

                function applyMode() {
                    teardown();
                    if (mq.matches) {
                        initDesktop();
                    } else {
                        initMobile();
                    }
                }

                applyMode();

                function onMqChange() { applyMode(); }
                if (mq.addEventListener) {
                    mq.addEventListener("change", onMqChange);
                } else if (mq.addListener) {
                    mq.addListener(onMqChange);
                }

                var resizeTimer;
                function onResize() {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        setEqualHeights();
                        if (mq.matches) updateDesktopArrows();
                    }, 150);
                }
                $window.addEventListener("resize", onResize);

                $scope.$on("$destroy", function () {
                    teardown();
                    $window.removeEventListener("resize", onResize);
                    if (mq.removeEventListener) {
                        mq.removeEventListener("change", onMqChange);
                    } else if (mq.removeListener) {
                        mq.removeListener(onMqChange);
                    }
                });
            }, 0);
        };
        return directive;
    },
]);
